import { Link } from "react-router-dom";

interface IndustrialFooterProps {
  minimal?: boolean;
  ctaHeadline?: string;
  ctaText?: string;
  ctaButtonLabel?: string;
  ctaButtonLink?: string;
}

const IndustrialFooter = ({
  minimal = false,
  ctaHeadline = "DEPLOYMENT PENDING.",
  ctaText = "The architecture is proven. If your operation meets the criteria, initiate the intake sequence.",
  ctaButtonLabel = "REQUEST DIAGNOSTIC",
  ctaButtonLink = "/intake",
}: IndustrialFooterProps) => {
  const currentYear = new Date().getFullYear();

  const NavLinks = () => (
    <div className="grid grid-cols-2 gap-8">
      <div>
        <h4 className="font-mono font-bold uppercase tracking-[0.12em] text-void-muted mb-2" style={{ fontSize: "0.7rem" }}>
          SYSTEM.MOD_
        </h4>
        <div className="flex flex-col gap-4">
          <Link to="/protocol" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">PROTOCOL</Link>
          <Link to="/infrastructure" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">INFRASTRUCTURE</Link>
          <Link to="/systems" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">SYSTEMS</Link>
          <Link to="/blog" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">INTEL [BLOG]</Link>
        </div>
      </div>
      <div>
        <h4 className="font-mono font-bold uppercase tracking-[0.12em] text-void-muted mb-2" style={{ fontSize: "0.7rem" }}>
          UTILITY_
        </h4>
        <div className="flex flex-col gap-4">
          <Link to="/intake" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">INTAKE PORTAL</Link>
          <Link to="/privacy" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">PRIVACY POLICY</Link>
          <Link to="/terms" className="text-[0.9rem] font-bold uppercase no-underline text-inherit transition-colors hover:text-primary">TERMS OF SERVICE</Link>
        </div>
      </div>
    </div>
  );

  return (
    <footer className="void-section border-t border-void-border-strong">
      <div className="max-w-industrial mx-auto px-6 md:px-16 pt-12 pb-10 md:pt-20 md:pb-10">
        {minimal ? (
          <div className="max-w-[500px]">
            <NavLinks />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
            <div>
              <h3
                className="font-black uppercase leading-[0.95] mb-6"
                style={{ fontSize: "clamp(2.5rem, 5vw, 5rem)" }}
              >
                {ctaHeadline}
              </h3>
              <p className="text-void-muted leading-relaxed max-w-[400px] mb-8" style={{ fontSize: "0.95rem" }}>
                {ctaText}
              </p>
              <Link
                to={ctaButtonLink}
                className="inline-block px-8 py-5 md:px-12 md:py-6 bg-primary text-white font-black uppercase text-base md:text-lg tracking-[0.05em] no-underline border-2 border-primary transition-all hover:bg-white hover:text-black"
              >
                {ctaButtonLabel}
              </Link>
            </div>
            <NavLinks />
          </div>
        )}
      </div>

      {/* Bottom Bar */}
      <div className="max-w-industrial mx-auto px-6 md:px-16">
        <div className="border-t border-void-border py-6 text-center">
          <span className="font-mono text-void-muted" style={{ fontSize: "0.8rem" }}>
            © {currentYear} WILLIAM PALMER // SYS.OP [ V1.0 - {currentYear} ]
          </span>
        </div>
      </div>
    </footer>
  );
};

export default IndustrialFooter;
